import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

type NavPortalProps = {
  children: React.ReactNode;
};

export const NavPortal = ({ children }: NavPortalProps) => {
  const ref = useRef<HTMLElement | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    ref.current = document.querySelector("#navbar-portal-container");
    setMounted(true);
  }, []);

  return mounted && ref.current ? createPortal(children, ref.current) : null;
};
